// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedGlobalIdModel {
    static getAttributeTypeMap() {
        return SiteSharedGlobalIdModel.attributeTypeMap;
    }
}
SiteSharedGlobalIdModel.discriminator = undefined;
SiteSharedGlobalIdModel.additionalProperties = false;
SiteSharedGlobalIdModel.attributeTypeMap = [
    {
        "name": "id",
        "baseName": "id",
        "type": "number"
    },
    {
        "name": "globalIdTypeCode",
        "baseName": "globalIdTypeCode",
        "type": "string"
    },
    {
        "name": "globalId",
        "baseName": "globalId",
        "type": "string"
    },
];
//# sourceMappingURL=siteSharedGlobalIdModel.js.map